export enum DataPageExport {
    GeneralExport = '0',
    RawData = '-1'
}
